import { AuthConsumer } from 'providers/authProvider'
import LoadingScreen from 'components/loading-screen';

export const SigninOIDC = () => (
    <AuthConsumer>
        {({ signinRedirectCallback }) => {
            signinRedirectCallback()
            return <LoadingScreen />
        }}
    </AuthConsumer>
)
